const SIDEBAR_WIDTH = 40;

var timerResizeSidebar;

// Read initial state from the class applied by the inline <head> script
var sidebarExpanded = !document.documentElement.classList.contains('sidebar-is-collapsed');

// Re-enable transitions after the first frame so toggle clicks animate smoothly
requestAnimationFrame(function () {
    requestAnimationFrame(function () {
        document.documentElement.classList.remove('sidebar-no-transition');
    });
});

/**
 * Init Sidebar — only handle the mobile override on DOM ready.
 * Desktop state is already applied pre-render by the inline <head> script.
 */
window.initSidebar = function () {
    if ($('body').width() < 768) {
        expandSidebar();
    }
};

/**
 * Expand Sidebar.
 */
window.expandSidebar = function () {
    document.documentElement.classList.remove('sidebar-is-collapsed');
    sidebarExpanded = true;
    try { localStorage.setItem('sidebar', 'expanded'); } catch (e) {}
};

/**
 * Collapse Sidebar.
 */
window.collapseSidebar = function () {
    document.documentElement.classList.add('sidebar-is-collapsed');
    sidebarExpanded = false;
    try { localStorage.setItem('sidebar', 'collapsed'); } catch (e) {}
};

/**
 * Resize Sidebar.
 */
window.resizeSidebar = function () {
    clearTimeout(timerResizeSidebar);
    timerResizeSidebar = setTimeout(function () {
        if ($('body').width() < 768) {
            expandSidebar();
        }
    }, 1000);
};

/**
 * Toggle Sidebar on click.
 */
$('#sidebar-toggle').on('click', function () {
    if (sidebarExpanded) {
        collapseSidebar();
    } else {
        expandSidebar();
    }
    resizeChosen();
});
